import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { SupportImage } from 'images';
import { numberWithCommas } from 'utils';

const TipSelectorWrapper = styled.div`
  width: 100%;
  min-width: 0;
`;

const TipCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 24px;
  width: 100%;
  min-width: 0;
  background: #f5fbee;
  border: 1px solid #d5d7da;
  border-radius: 8px;
`;

const TipInfo = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const TipTitle = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.85);
`;

const TipText = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.65);
`;

const SliderBlock = styled.div`
  width: 100%;
`;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  display: inline-block;
  margin-bottom: 18px;
`;

const Tooltip = styled.div`
  position: absolute;
  top: -45px;
  left: ${(props) => props.left}px;
  transform: translateX(-50%);
  background: #ffffff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  min-width: 90px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  margin-top: 16px;
  pointer-events: none;

  span {
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
    white-space: nowrap;
  }

  .amount {
    font-weight: 700;
  }
`;

const SliderInput = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  outline: none;
  margin: 0;
  margin-top: 12px;
  background: #e0e0e0;
  opacity: 0.9;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-runnable-track {
    height: 8px;
    border-radius: 4px;
    background: ${(props) =>
      `linear-gradient(to right, #9dbc60 ${props.progress}%, #e0e0e0 ${props.progress}%)`};
  }

  &::-moz-range-track {
    height: 8px;
    border-radius: 4px;
    background: #e0e0e0;
  }

  &::-moz-range-progress {
    height: 8px;
    border-radius: 4px;
    background: #9dbc60;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 24px;
    height: 24px;
    margin-top: -8px;
    border-radius: 50%;
    background: #ffffff;
    border: 2px solid #9dbc60;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ffffff;
    border: 2px solid #9dbc60;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const SliderTicks = styled.div`
  position: absolute;
  padding-left: 11px;
  padding-right: 15px;
  top: 50%;
  left: 0;
  width: 100%;
  height: 12px;
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  transform: translateY(-50%);
  margin-top: 6px;
  box-sizing: border-box;

  span {
    width: 4px;
    height: 4px;
    background-color: #ffffff;
    border-radius: 50%;
    position: relative;
    margin-top: 4px;
  }

  span.multiple-of-5 {
    width: 2px;
    height: 8px;
    background-color: #ffffff;
    border-radius: 0;
    margin-top: 2px;
  }
`;

const UnderlineButtonWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const UnderlineButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.85);
`;

const CustomAmountWrap = styled.div`
  width: 100%;
`;

const CustomAmountLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.85);
`;

const CustomAmountInputWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 52px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  border-radius: 8px;
`;

const CustomAmountInput = styled.input`
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  padding: 0 16px;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

const Euro = styled.span`
  padding-right: 16px;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
`;

const SupportBox = styled.div`
  width: 100%;
  margin-top: 18px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 16px;
  background-color: #fff;
`;

const SupportInner = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: 10px;
  padding: 8px;
  margin-top: 20px;
  align-items: center;
  text-align: center;

`;

const SupportImg = styled.img`
  width: 100%;
  max-width: 130px;
  max-height: 130px;
  align: justify;
`;

const SupportText = styled.div`
  width: 100%;
  margin-bottom: 10px;
  color: #646464;
  font-size: 16px;
  text-align: center;
`;

const SupportLink = styled.a`
  font-size: 16px;
  color: #93b158;
  justify-content: center;
  align-self: center;
  text-decoration: underline;
  text-align: center;
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 9999;
`;

const ModalBox = styled.div`
  width: 100%;
  max-width: 560px;
  max-height: 80vh;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
`;

const ModalText = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  font-size: 15px;
  line-height: 24px;
  color: #414651;
  margin-bottom: 20px;
`;

const ModalClose = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
`;

const CommonsplaceAddition = ({
  usedDonation,
  setFreiwilligesState,
  defaultTip,
}) => {
  const sliderRef = useRef(null);

  const minSliderPercentage = 5;
  const maxSliderPercentage = 35;

  const safeUsedDonation = Number(usedDonation) || 0;
  const safeDefaultTip = Number(defaultTip) || 0;

  const getInitialPercentage = () => {
    if (!safeUsedDonation || !safeDefaultTip) return 20;
    const calculated = Math.round((safeDefaultTip * 100) / safeUsedDonation);
    if (calculated < minSliderPercentage) return minSliderPercentage;
    if (calculated > maxSliderPercentage) return maxSliderPercentage;
    return calculated;
  };

  const [showInput, setShowInput] = useState(false);
  const [tipPercentage, setTipPercentage] = useState(getInitialPercentage());
  const [customTip, setCustomTip] = useState(
    safeDefaultTip ? String(safeDefaultTip) : ''
  );
  const [showDetailsBox, setShowDetailsBox] = useState(
    getInitialPercentage() === 5
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tooltipLeft, setTooltipLeft] = useState(40);

  const progress =
    ((tipPercentage - minSliderPercentage) /
      (maxSliderPercentage - minSliderPercentage)) *
    100;

  const currentTipAmount = Number(
    ((safeUsedDonation * tipPercentage) / 100).toFixed(2)
  );

  const formatAmount = (value) => {
    try {
      return numberWithCommas(Number(value).toFixed(2));
    } catch (e) {
      return Number(value).toFixed(2);
    }
  };

  const updateTooltipPosition = () => {
    const slider = sliderRef.current;
    if (!slider) return;

    const min = Number(slider.min);
    const max = Number(slider.max);
    const value = Number(slider.value);
    const sliderWidth = slider.offsetWidth;
    const thumbWidth = 24;
    const percent = (value - min) / (max - min);
    const left = percent * (sliderWidth - thumbWidth) + thumbWidth / 2;

    setTooltipLeft(left);
  };

  useEffect(() => {
    if (!showInput) {
      const initialPercentage = getInitialPercentage();
      setTipPercentage(initialPercentage);
      const initialTip = Number(
        ((safeUsedDonation * initialPercentage) / 100).toFixed(2)
      );
      setFreiwilligesState(initialTip);
      setShowDetailsBox(initialPercentage === 5);
    } else {
      setCustomTip(safeDefaultTip ? String(safeDefaultTip) : '');
      setFreiwilligesState(safeDefaultTip || 0);
      setShowDetailsBox((safeDefaultTip || 0) === 0);
    }
  }, [usedDonation]);

  useEffect(() => {
    if (!showInput) {
      setTimeout(updateTooltipPosition, 0);
      window.addEventListener('resize', updateTooltipPosition);

      return () => {
        window.removeEventListener('resize', updateTooltipPosition);
      };
    }
  }, [showInput, tipPercentage]);

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  const handleSliderChange = (e) => {
    const percentage = Number(e.target.value);
    setTipPercentage(percentage);

    const calculatedTip = Number(
      ((safeUsedDonation * percentage) / 100).toFixed(2)
    );
    setFreiwilligesState(calculatedTip);
    setShowDetailsBox(percentage === 5);
  };

  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, '');

    setCustomTip(value);

    const numericValue = Number(value || 0);
    setFreiwilligesState(numericValue);
    setShowDetailsBox(numericValue === 0);
  };

  const handleShowInput = () => {
    setShowInput(true);
    const calculatedTip = Number(
      ((safeUsedDonation * tipPercentage) / 100).toFixed(2)
    );
    setCustomTip(calculatedTip ? String(calculatedTip) : '');
    setShowDetailsBox(calculatedTip === 0);
  };

  const handleShowSlider = () => {
    let calculatedPercentage = minSliderPercentage;

    if (safeUsedDonation > 0) {
      calculatedPercentage = Math.ceil(
        (Number(customTip || 0) * 100) / safeUsedDonation
      );
    }

    if (calculatedPercentage < minSliderPercentage) {
      calculatedPercentage = minSliderPercentage;
    }

    if (calculatedPercentage > maxSliderPercentage) {
      calculatedPercentage = maxSliderPercentage;
    }

    setTipPercentage(calculatedPercentage);

    const calculatedTip = Number(
      ((safeUsedDonation * calculatedPercentage) / 100).toFixed(2)
    );
    setFreiwilligesState(calculatedTip);
    setShowInput(false);
    setShowDetailsBox(calculatedPercentage === 5);
  };

  return (
    <TipSelectorWrapper>
      <TipCard>
        <TipInfo>
          <TipTitle>Freiwilliger Beitrag für commonsplace 💚</TipTitle>
          <TipText>
            Wir helfen der deutsch-muslimischen Community, ihre Werte
            selbstorganisiert zu leben und die Gesellschaft mitzugestalten.
            Damit commonsplace unabhängig wächst, brauchen wir deine
            Unterstützung.
          </TipText>
        </TipInfo>

        {!showInput ? (
          <SliderBlock>
            <SliderContainer>
              <Tooltip left={tooltipLeft}>
                <span>
                  <span className="amount">
                    {formatAmount(currentTipAmount)} €
                  </span>{' '}
                  ({tipPercentage} %)
                </span>
              </Tooltip>

              <SliderInput
                ref={sliderRef}
                type="range"
                min={minSliderPercentage}
                max={maxSliderPercentage}
                step="1"
                value={tipPercentage}
                onChange={handleSliderChange}
                progress={progress}
              />
              <SliderTicks>
                {[...Array(maxSliderPercentage - minSliderPercentage + 1)].map(
                  (_, index) => {
                    const value = index + minSliderPercentage;
                    return (
                      <span
                        key={value}
                        className={value % 5 === 0 ? 'multiple-of-5' : ''}
                        style={{
                          left: `${
                            index / (maxSliderPercentage - minSliderPercentage)
                          }%`,
                        }}
                      />
                    );
                  }
                )}
              </SliderTicks>
            </SliderContainer>

            <UnderlineButtonWrap>
              <UnderlineButton type="button" onClick={handleShowInput}>
                Eigener Betrag
              </UnderlineButton>
            </UnderlineButtonWrap>
          </SliderBlock>
        ) : (
          <CustomAmountWrap>
            <CustomAmountLabel>Eigener Betrag</CustomAmountLabel>

            <CustomAmountInputWrap>
              <CustomAmountInput
                type="number"
                value={customTip}
                placeholder="0"
                onChange={handleInputChange}
              />
              <Euro>€</Euro>
            </CustomAmountInputWrap>

            <UnderlineButtonWrap style={{ marginTop: 12 }}>
              <UnderlineButton type="button" onClick={handleShowSlider}>
                Zurück zur Standardeinstellung
              </UnderlineButton>
            </UnderlineButtonWrap>
          </CustomAmountWrap>
        )}

        {showDetailsBox && (
          <SupportBox>
            <SupportInner>
              <SupportImg src={SupportImage} alt="commonsplace support" />
              <SupportText>
                Mit deiner Hilfe vernetzt commonsplace nachhaltig Unterstützer
                mit wichtigen Projekten. So wächst die Community und entfaltet
                Wirkung. Ohne Beiträge bleibt die Vision begrenzt.
              </SupportText>
            </SupportInner>

            <SupportLink type="button" onClick={() => setIsModalOpen(true)}>
              Warum unterstützen?
            </SupportLink>
          </SupportBox>
        )}
      </TipCard>

      {isModalOpen && (
        <ModalOverlay>
          <ModalBox>
            <ModalText>
              Gemeinsam die deutsch-muslimische Community stärken!
              <br />
              <br />
              Unterstütze uns, um deine Community zu unterstützen!
              <br />
              <br />
              commonsplace ist mehr als nur eine Plattform – wir verbinden,
              fördern und ermöglichen muslimische Projekte in Deutschland. Mit
              der Kraft und Kreativität der Community unterstützen wir soziale
              Initiativen, Moscheeprojekte, Bildungsprojekte und muslimisches
              Unternehmertum.
              <br />
              <br />
              Auch wir sind auf die Unterstützung der Community angewiesen –
              commonsplace wird durch freiwillige Beiträge finanziert.
              <br />
              <br />
              Danke, dass du Teil dieser Vision bist.
            </ModalText>

            <ModalClose type="button" onClick={() => setIsModalOpen(false)}>
              Schließen
            </ModalClose>
          </ModalBox>
        </ModalOverlay>
      )}
    </TipSelectorWrapper>
  );
};

export default CommonsplaceAddition;
